export default "__VITE_ASSET__BVrVCwtE__"